import React from 'react';
import logo from './cube.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          We are currently in stealth mode.<br/>
            <br/>Please visit again later.
        </p>
      </header>
    </div>
  );
}

export default App;
